export default "__VITE_ASSET__0b413372__"